import React, { useEffect, useState } from 'react';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import SvgTagEdit from '@components/ringil3/icons/TagEdit.tsx';
import { InputText } from 'primereact/inputtext';
import { Field } from '@components/framework/formfield/Field.tsx';
import { isNotBlank } from '@utils/utils.tsx';

interface CarrierApiField {
  key: string;
  label: string;
  value?: string;
}

interface ComponentProps {
  secured?: SecuredConfig;
  label: string;
  fields: CarrierApiField[];
  onChange: (values: Record<string, string>) => void;
  readOnly?: boolean;
  dataTestId?: string;
}

const toValues = (fields: CarrierApiField[]): Record<string, string> => Object.fromEntries(fields.map(f => [f.key, f.value ?? '']));

const LocationCarrierApiTag: React.FC<ComponentProps> = ({ secured, label, fields, onChange, readOnly, dataTestId }) => {
  const [internalValues, setInternalValues] = useState<Record<string, string>>(toValues(fields));

  const fieldsSignature = fields.map(f => `${f.key}:${f.value ?? ''}`).join('|');
  useEffect(() => setInternalValues(toValues(fields)), [fieldsSignature]);

  const displayValue = fields.map(f => f.value).find(v => isNotBlank(v));

  return (
    <ButtonTag
      secured={secured}
      label={label}
      value={displayValue}
      actionIcon={<SvgTagEdit />}
      popupWidth={'350px'}
      actionPane={
        <div className={'flex flex-col gap-2'}>
          {fields.map(field => (
            <Field key={field.key} label={field.label}>
              <InputText
                value={internalValues[field.key] ?? ''}
                onChange={e => setInternalValues(prev => ({ ...prev, [field.key]: e.target.value }))}
                data-testid={dataTestId ? `${dataTestId}-${field.key}` : undefined}
              />
            </Field>
          ))}
        </div>
      }
      onSave={onSuccess => {
        onChange(internalValues);
        onSuccess();
      }}
      readonly={readOnly}
      autoClose
      dataTestId={dataTestId}
    />
  );
};

export default LocationCarrierApiTag;
